import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import getCharCount from 'components/RichText/utils/getCharCount'
import trimRichText from 'components/RichText/utils/trim'
import RichTextEditor from 'components/RichText/Editor'
import {
  MenuItem
} from 'components/Menu'
import KanBoIcon from 'components/KanBoIcon'
import ActivityContentComponent, {
  ActivityAction
} from 'components/ActivityContent'
import classes from './ActivityContent.module.scss'

export class ActivityContent extends React.Component {
  static propTypes = {
    from: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    isBookmarked: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    isBusy: PropTypes.bool,

    cardContext: PropTypes.object.isRequired,

    boardId: PropTypes.number.isRequired,
    isArchived: PropTypes.bool.isRequired,

    requestEditMessage: PropTypes.func.isRequired,
    requestRemoveMessage: PropTypes.func.isRequired,
    requestAddBookmark: PropTypes.func.isRequired,
    requestRemoveBookmark: PropTypes.func.isRequired,
  }

  state = {
    editable: null,
    editing: false
  }

  componentDidMount () {
    const { timestamp } = this.props

    if (this.getCanEdit()) {
      const diff = moment().diff(moment(timestamp), 'seconds')
      const editableSeconds = 300 - diff // 5 Minutes
      const editable = editableSeconds > 0

      if (editable) {
        this.setState({
          editable: true
        })

        this.editTimeout = setTimeout(() => {
          this.setState({
            editable: false
          })
        }, editableSeconds * 1000)
      } else {
        this.setState({
          editable: false
        })
      }
    } else {
      this.setState({
        editable: false
      })
    }
  }

  componentWillUnmount () {
    if (this.editTimeout) {
      clearTimeout(this.editTimeout)
    }
  }

  getCanEdit () {
    const {
      data,
      fromUser,
      currentUser
    } = this.props

    return (
      data.action === 'AddCommentOnCard' ||
      data.action === 'EditCommentOnCard'
    ) && fromUser.type === 'USER' && fromUser.id === currentUser.id
  }

  handleEditClick = () => {
    this.setState({
      editing: true
    })
  }

  handleEditClose = () => {
    this.setState({
      editing: false
    })
  }

  handleEditMessageSubmit = (message) => {
    const { id, requestEditMessage } = this.props

    const contentCharCount = getCharCount(message)

    if (contentCharCount > 0) {
      requestEditMessage({
        messageId: id,
        message: trimRichText(message)
      })
    }
  }

  handleRemoveClick = () => {
    const { id, requestRemoveMessage } = this.props

    requestRemoveMessage({
      messageId: id
    })
  }

  handleAddBookmarkClick = () => {
    const { cardContext, id, requestAddBookmark } = this.props

    requestAddBookmark({
      cardId: cardContext.id,
      activityId: id
    })
  }

  handleRemoveBookmarkClick = () => {
    const { cardContext, id, requestRemoveBookmark } = this.props

    requestRemoveBookmark({
      cardId: cardContext.id,
      activityId: id
    })
  }

  render () {
    const {
      isBookmarked,
      isBusy,
      boardId,
      isArchived,

      cardContext,

      requestEditMessage,
      requestRemoveMessage,
      requestAddBookmark,
      requestRemoveBookmark,

      ...props
    } = this.props
    const {
      editable,
      editing
    } = this.state

    if (editable && editing) {
      return (
        <RichTextEditor
          autoFocus
          content={props.data.rtMessage}
          mentionBoardId={boardId}
          onBlur={this.handleEditClose}
          submitButton={<FormattedMessage id='SAVE' />}
          onSubmit={this.handleEditMessageSubmit}
        />
      )
    } else {
      const menu = [
        isBookmarked ? (
          <MenuItem
            icon={<KanBoIcon fixedWidth name='kanbo-16-unbookmark' />}
            onClick={this.handleRemoveBookmarkClick}
          >
            <FormattedMessage id='BOOKMARK_REMOVE' />
          </MenuItem>
        ) : (
          <MenuItem
            icon={<KanBoIcon fixedWidth name='kanbo-16-bookmark' />}
            onClick={this.handleAddBookmarkClick}
          >
            <FormattedMessage id='BOOKMARK_ADD' />
          </MenuItem>
        )
      ]
      if (!isArchived && !isBusy && editable && !editing) {
        menu.push(
          (
            <MenuItem
              icon={<KanBoIcon fixedWidth name='kanbo-16-card-action' />}
              onClick={this.handleEditClick}
            >
              <FormattedMessage id='CARD_COMMENT_EDIT' />
            </MenuItem>
          ),
          (
            <MenuItem
              icon={<KanBoIcon fixedWidth name='kanbo-16-remove' />}
              onClick={this.handleRemoveClick}
            >
              <FormattedMessage id='CARD_COMMENT_REMOVE' />
            </MenuItem>
          )
        )
      }

      return (
        <ActivityContentComponent
          {...props}
          menu={menu}
          actions={
            isBookmarked && (
              <ActivityAction
                className={classes.bookmark}
                icon={
                  <KanBoIcon name='kanbo-16-solid-bookmarked' />
                }
                onClick={this.handleRemoveBookmarkClick}
              />
            )
          }
        />
      )
    }
  }
}

export default ActivityContent
